const stMob = {
  containCopyAndPaste: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    borderRadius: '5px',
  },
  textCopyAndPaste: {
    width: '100%',
    height: 'auto',
    fontSize: '15px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}

export { stMob }
